import React, {useRef} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {Row, Col} from 'reactstrap';
import ReactSelect from '../../../Shared/ReactSelect/ReactSelect';
import TextInput from '../../../Shared/TextInput/TextInput';
import {
  changeHandler,
  validateHandler,
  getTimeSlots,
  getTimeSlotsFromDate,
  startLoading,
  initValidation,
  clearValid,
  setFloorValidation,
} from './TechnicianArrivalTimeSlice';
import {connect} from 'react-redux';
import {addDays} from './../../../../utilities/dateUtils';
import {showAppLoader, hideAppLoader, showOverlay} from '../../../Shared/Loader/LoaderSlice';
import {getRecaptchaToken} from './../../../../utilities/recaptcha/recaptcha';
import Config from '../../../../Config';

const TechnicianArrivalTime = (props) => {
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      if (props.selectedAddress.infrastructure.tashtitType == 'BF') {
        props.setFloorValidation();
      }
    }
    props.showAppLoader();
    props.showOverlay(true);
    getTechnicianSlots();
  }, []);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.form.isLoading == false) {
          props.showOverlay(false);
          props.hideAppLoader();
        }
      }
    },
    [props.form.timeSlots]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.onSubmit && props.onSubmit == true) {
          props.validateHandler(props.form);
        }
      }
    },
    [props.onSubmit]
  );

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      if (props.form.errorObj != '') {
        props.hideAppLoader();
        props.onError(props.form.errorObj.errorId);
      }

      if (props.form.valid !== '') {
        props.clearValid();
        props.onValid(props.form.valid);
        props.initValidation();
      }
    }
  });

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      if (props.form.errorObj != '') {
        props.hideAppLoader();
        props.onError(props.form.errorObj.errorId);
      }
    }
  }, []);

  async function getTechnicianSlots() {
    if (props.selectedAddress) {
      const isBeforeConnection = props.selectedAddress.infrastructure.assetMarketStatus == 'בניין לקראת חיבור';
      const connectionDate = new Date(props.selectedAddress.infrastructure.assetDateSalesTarget);
      const today = new Date();
      const maxDate = addDays(today, 60);
      const token = await getRecaptchaToken('techSlots');
      let params = {};
      let typeName = Config.isTimeSlotsGetFromClick ? 'התקנת TV' : 'התקנת IPTV';

      if (props.selectedAddress.infrastructure.tashtitType == 'IBC') typeName = 'התקנת תשתית IBC';

      if (props.selectedAddress.infrastructure.tashtitType == 'FIBER' || props.selectedAddress.infrastructure.tashtitType == 'BF')
        typeName = 'התקנת תשתית סיבים';

      let distributionType = props.selectedAddress.infrastructure.distributionType;
      if (distributionType == '') distributionType = null;

      let infrastructure = props.selectedAddress.infrastructure.infrastructure;
      if (infrastructure == '') infrastructure = null;

      if (isBeforeConnection && connectionDate < maxDate) {
        params = {
          city: props.selectedAddress.cityName,
          zipCode: props.selectedAddress.zipCode,
          typeName: typeName,
          cityCode: props.selectedAddress.city,
          streetCode: props.selectedAddress.street,
          distributionType: distributionType,
          infrastructure: infrastructure,
          entrance: props.selectedAddress.enter == '' ? ' ' : props.selectedAddress.enter,
          fromDate: addDays(props.selectedAddress.infrastructure.assetDateSalesTarget, 2), //2020-11-30T00:00:00+02:00
          addDays: '12',
          captchaToken: token,
          flowType: props.saleFlowType,
          otpPhone: props.saleOtpPhone,
        };
        props.getTimeSlotsFromDate(params);
      } else {
        params = {
          city: props.selectedAddress.cityName,
          zipCode: props.selectedAddress.zipCode,
          cityCode: props.selectedAddress.city,
          distributionType: distributionType,
          infrastructure: infrastructure,
          streetCode: props.selectedAddress.street,
          entrance: props.selectedAddress.enter == '' ? ' ' : props.selectedAddress.enter,
          typeName: typeName,
          captchaToken: token,
          flowType: props.saleFlowType,
          otpPhone: props.saleOtpPhone,
        };

        props.getTimeSlots(params);
      }
    }
  }

  return (
    <div>
      <div className='container-fluid main'>
        <div className='setup-address component-container'>
          {props.subTitle && props.subTitle != '' && (
            <Row>
              <Col ms={12}>
                <h1 className='top-title'>{props.subTitle}</h1>
              </Col>
            </Row>
          )}

          {props.selectedAddress.infrastructure.tashtitType == 'BF' && (
            <Row>
              <Col>
                <div>
                  <div class='field-remark'>*אם אתם גרים בבית פרטי רישמו קומה 1</div>
                  <TextInput
                    error={props.form.errors.floor}
                    placeholder='מספר קומה'
                    id='floor'
                    name='floor'
                    maxLength='4'
                    disabled=''
                    type='number'
                    pattern='[0-9]*'
                    autoComplete='off'
                    value={props.form.floor != undefined ? props.form.floor : ''}
                    onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
                    required='required'
                  />
                </div>
              </Col>
            </Row>
          )}

          <Row>
            <Col ms={12}>
              <div>
                <p>תאום יום ושעה</p>
                <p>יש חלונות זמן קבועים עבור הגעת טכנאי</p>
                <ReactSelect
                  inputProps={{readOnly: true}}
                  isSearchable={false}
                  error={props.form.errors.arrivalTime}
                  getOptionLabel={(option) => option.value}
                  getOptionValue={(option) => option.key}
                  placeholder='בחר מועד'
                  isLoading={props.form.isLoading}
                  value={props.form.timeSlots.filter((option) => option.key === props.form.arrivalTime)}
                  name='arrivalTime'
                  options={props.form.timeSlots}
                  onChange={(e) =>
                    props.changeHandler({
                      target: {name: 'arrivalTime', value: e.key, startDate: e.startDate, endDate: e.endDate},
                      startDate: e.startDate,
                      endDate: e.endDate,
                      form: props.form,
                    })
                  }
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    form: state.technicianArrivalTime.form,
    tashtitType: state.addressForm.infrastructure.tashtitType,
    saleOtpTicketId: state.saleBlock.otpTicketId,
    saleFlowType: state.saleBlock.flowType,
    saleOtpPhone: state.saleBlock.otpPhone,
  };
};

const mapDispatchToProps = {
  changeHandler,
  validateHandler,
  getTimeSlots,
  startLoading,
  hideAppLoader,
  showAppLoader,
  showOverlay,
  getTimeSlotsFromDate,
  initValidation,
  clearValid,
  setFloorValidation,
};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianArrivalTime);
